const REQUIRED_DATA_EXEMPT_ROLES = ['admin'];
export const MAX_DNI_PHONE_LENGTH = 20;
export const MAX_SURNAME_LENGTH = 40;

export const normalizeDni = value =>
  String(value || '')
    .trim()
    .toUpperCase();

export const normalizePhone = value => String(value || '').trim();

export const normalizeSurname = value => String(value || '').trim();

export const isValidEmail = email =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());

export const isValidDni = dni => {
  const normalized = normalizeDni(dni);
  return normalized.length > 0 && normalized.length <= MAX_DNI_PHONE_LENGTH;
};

export const isValidPhone = phone => {
  const normalized = normalizePhone(phone);
  return normalized.length > 0 && normalized.length <= MAX_DNI_PHONE_LENGTH;
};

export const isValidSurname = surname => {
  const normalized = normalizeSurname(surname);
  return normalized.length > 0 && normalized.length <= MAX_SURNAME_LENGTH;
};

export const getRequiredUserDataErrors = user => {
  const errors = [];

  if (REQUIRED_DATA_EXEMPT_ROLES.includes(user?.role)) {
    return errors;
  }

  if (!String(user?.name || '').trim()) errors.push('nombre');
  if (!isValidSurname(user?.surname)) errors.push('apellidos');
  if (!isValidEmail(user?.email)) errors.push('email válido');
  if (!isValidDni(user?.dni)) {
    errors.push('DNI/NIE');
  }
  if (!isValidPhone(user?.phone)) {
    errors.push('teléfono');
  }

  return errors;
};

export const getRequiredUserDataMessage = user => {
  const errors = getRequiredUserDataErrors(user);

  if (errors.length === 0) {
    return '';
  }

  return `Antes de reservar debes completar en tu perfil: ${errors.join(', ')}.`;
};
